import { ListFilter } from 'lucide-react';

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SelectLabel,
  SelectSeparator,
} from '@/components/ui/select';
import { useLocalStorage } from 'src/hooks';
import { SOFTWARE_ESCROWS_FILTER_STORAGE_KEY } from 'src/shared/constants';

import { filterOptions, useDashboard } from '../model';

const FilterSelect = () => {
  const { setStatusFilter, status } = useDashboard();
  const [, setSavedStatus] = useLocalStorage(SOFTWARE_ESCROWS_FILTER_STORAGE_KEY, '');

  const { status: statusOption, requests } = filterOptions;

  const onChange = (value: string) => {
    setStatusFilter(value);
    setSavedStatus(value);
  };

  return (
    <Select onValueChange={onChange} value={status}>
      <SelectTrigger
        className="w-10 sm:w-50 *:data-[slot=select-value]:hidden sm:*:data-[slot=select-value]:block"
        icon={ListFilter}
      >
        <SelectValue placeholder="Filter" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All</SelectItem>
        <SelectGroup>
          <SelectSeparator />
          <SelectLabel>{statusOption.label}</SelectLabel>
          {statusOption.items.map(({ value, label }) => (
            <SelectItem value={value} key={value}>
              {label}
            </SelectItem>
          ))}
        </SelectGroup>
        <SelectSeparator />
        <SelectGroup>
          <SelectLabel>{requests.label}</SelectLabel>
          {requests.items.map(({ value, label }) => (
            <SelectItem value={value} key={value}>
              {label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};

export default FilterSelect;
